/**
 * Created with IntelliJ IDEA.
 * User: vanessat
 * Date: 11/19/14
 * Time: 6:30 PM
 * To change this template use File | Settings | File Templates.
 */
define(function (require) {

    var _ = require('underscore');
    var lpUtils = require('utils/lpUtils');
    var WebAgentLogger = require('web-agent-assets-js/WebAgentLogger');
    var lpAgent = require('web-agent-assets-js/lpAgent');
    var AgentList = require('web-agent-assets-js/lpAgentList');
    var agentLEManager = require('web-agent-utils/agentLEManager');
    var privilegesController = require('web-agent-assets-js/lpPrivilegesController');

    var lpAgentListController = function (model) {
        var agentListController = {applicationType: "lpAgentListController"};

        var requestStatuses = {
            FETCHING: "fetching",
            FETCHED: "fetched",
            PUBLISHED: "published",
            ERROR: "error"
        };

        var logger = WebAgentLogger.getLogger(agentListController.applicationType);

        var AGENT_STATUS = {
            offline: "1",
            online: "2",
            backSoon: "3",
            away: "4"
        };

        var reportingDatabarData = {
            totalAgentsOnline: 0,
            totalAgentsBackSoon: 0,
            totalAgentsAway: 0,
            concurrentChats: 0,
            maxConcurrentChats: 0
        };

        var agentListApi;
        var receivedSkills;
        var receivedAgentList = false;
        var requestedAgentList = false;

        var defaultQueryParams = {};
        var lastQuery = {};
        var lastCount;

        var defaultBodyData = {
            status: AGENT_STATUS.online,
            sort: "name:asc"
        };

        var defaultSearchUIData = {
            limit: defaultQueryParams.limit,
            sortTag: defaultBodyData.sort.substring(0, defaultBodyData.sort.indexOf(":")),
            sortOrder: defaultBodyData.sort.substring(defaultBodyData.sort.indexOf(":") + 1),
            agentStatus: {
                status: defaultBodyData.status
            }
        };

        var agentListModel = model;

        agentListController.getDefaultValue = function (valueName) {
            if (valueName) {
                var sValue = valueName.split('.');
                var retVal = defaultSearchUIData;
                while (sValue.length) {
                    retVal = retVal[sValue.shift()];
                }
                return lpUtils.cloneObject(retVal);
            }
        };

        agentListController.getModelParam = function (paramName) {
            return agentListModel.get(paramName);
        };

        agentListController.bindModelParam = function (modelParam, func, scope, trigger) {
            agentListModel.bind(modelParam, func, scope, trigger);
        };

        agentListController.unbindModelParam = function (key, callback, context) {
            agentListModel.unbind(key, callback, context);
        };

        agentListController.getSessionData = function (data) {
            return getSessionData(data);
        };

        agentListController.saveSessionData = function (data) {
            saveSessionData(data);
        };

        agentListController.removeSessionData = function (data) {
            removeSessionData(data);
        };


        agentListController.updateQuery = function (searchData) {
            updateQuery(searchData);
            searchAgents();
        };

        agentListController.startPolling = function () {
            searchAgents();
        };

        agentListController.stopPolling = function () {
            if (agentListApi) {
                agentListApi.stopPolling();
            }
        };

        function updateQuery(searchData) {
            for (var item in searchData) {
                if (typeof searchData[item] === 'undefined') {
                    model.removeKey("agentList.lastQuery." + item);
                }
            }
            agentListModel.modify("agentList.lastQuery", searchData);
            lastQuery = agentListModel.get("agentList.lastQuery");
            saveSessionData({name: "lpAgentListController", key: "lastQuery", value: lastQuery});
        }

        initialize();

        function initialize() {

            var savedQuery = getSessionData({name: "lpAgentListController", key: "lastQuery"});
            if (typeof(savedQuery) === "undefined" || savedQuery === null || savedQuery === "") {
                savedQuery = defaultSearchUIData;
            }
            lastQuery = savedQuery;
            agentListModel.set("agentList.lastQuery", lastQuery);

            agentListModel.bind('skills.state', apiStateChanged, this);
            agentListModel.bind('application.status', handleStatusChanged, this);
        }

        function translateQueryToSearchObject() {
            var data = model.get("agentList.lastQuery");

            var queryParams = lpUtils.cloneObject(defaultQueryParams);
            var bodyData = lpUtils.cloneObject(defaultBodyData);

            // Pre-filtering according to the allowed agent groups. This will be overridden if there's an actual filter.
            if (privilegesController.hasAgentManagerModulePrivilege()) {      //manager privilege will see managed groups' members
                bodyData.agentGroupIds = getArrayOfManagedGroupIds();
            } else {                                                                        //agent privilege will show the other members of my group
                bodyData.agentGroupIds = getMyGroupId();
            }

            logger.info("", "updateSearchData", data);
            if (data) {
                for (var key in data) {
                    if (data.hasOwnProperty(key)) {
                        switch (key) {
                            case    "agentStatus":
                                bodyData.status = data[key].status; break;
                            case    "sortTag":
                                bodyData.sort = data[key] + ":" + data.sortOrder; break;
                            case    "skillNames":
                                if (data[key]) {
                                    bodyData.skill = data[key];
                                }
                                else {
                                    delete bodyData.skill;
                                }
                                break;
                            case    "agentGroupIds":
                                bodyData.agentGroupIds = data[key];                         //filtering by group ID will override default groups
                                break;
                            default : break;
                        }
                    }
                }
            }

            return {
                bodyData: bodyData,
                queryParams: queryParams
            };
        }

        function getArrayOfManagedGroupIds() {
            var res;
            var agentGroupArray = agentListController.getModelParam("agent.agentGroups.array"); //put there by the agentGroupDataManager

            if (agentGroupArray && agentGroupArray.length > 0) {
                res = agentGroupArray.map(function (key) {
                    return key.id;
                }).join(",");
            } else {
                res = getMyGroupId(); //fallback for a manager who is also an agent and is not managing any groups, but is a member of one.
            }
            return res;
        }

        function getMyGroupId() {
            var myAgentGroupId = agentListController.getModelParam("agent.agentGroupId");
            if(myAgentGroupId) {
                return myAgentGroupId + "";
            }
        }

        function searchAgents() {
            if (!agentListApi) {
                requestedAgentList = true;
                return;
            }

            var searchObject = translateQueryToSearchObject();

            var requestObj = {
                success: handleSearchSuccess,
                error: handleSearchError,
                query: searchObject.queryParams,
                data: searchObject.bodyData,
                pollingTimeout: lpTag.WebAgent.logicController.getPollingRefreshRateFromSiteSettings("le.agent.agentList.refreshRate", 30000)
            };

            // will throw an exception if no rel is found in the session data (lpAgent didn't fetched it from server)
            agentListApi.searchAgents(requestObj);
            agentListModel.set("agentList.state", {status: requestStatuses.FETCHING});
        }

        function initializeApi() {
            var baseUrl = lpAgent.sessionDataManager.getSessionData('lpAgentRel');
            if (baseUrl) {
                agentListApi = new AgentList(baseUrl);
                if (requestedAgentList) { // In case we were asked to get the agent list prior to having an initialized API, we call the request now.
                    searchAgents();
                    requestedAgentList = false;
                }
            }
        }

        function handleStatusChanged(data) {
            if (data && typeof data.newValue !== 'undefined') {
                if (data.newValue !== "loggedOff") {
                    initializeApi();
                }
            }
        }

        function handleSearchSuccess(data) {
            logger.debug("Search return as Success", "handleSearchSuccess");

            // reset reporting data
            resetReportingData(0);

            if (data && data.body && data.body.availableAgents) {
                //if (data.body.availableAgents && data.body.availableAgents.agents && data.body.availableAgents.agents.agent) {
                receivedAgentList = true;
                setAgentListArray(data.body.availableAgents.agents);
                //}
            }

            // update reporting databar
            agentLEManager.setLEValue("webAgent.agentListDatabar", reportingDatabarData);
            LE.crossModule("reporting", LE.media.actions.command, "webAgent:agentListDatabarReady");
        }

        function handleSearchError(data) {
            logger.error("", "handleSearchError", data);
            logger.graph({name: 'searchAgentListError'});

            // reset reporting data
            resetReportingData(-2);

            agentListModel.set("agentList.state", { status: requestStatuses.ERROR, error : (data && data.body && data.body.code) || data || requestStatuses.ERROR});

            // update reporting databar
            agentLEManager.setLEValue('webAgent.agentListDatabar', reportingDatabarData);
            LE.crossModule("reporting", LE.media.actions.command, "webAgent:agentListDatabarReady");
        }

        /**
         * Set the agent list to the model
         * @param agentListArray
         */

        function setAgentListArray(agentListArray) {
            var agentsArray = getAgentsObject(agentListArray);
            var agentsObject = _.extend({}, agentsArray);
            agentListModel.set("agentList.data", agentsObject);
            agentListModel.set("agentList.array", agentsArray);
            agentListModel.set("agentList.count", lastCount);
            if (readyToDisplay()) {
                agentListModel.set("agentList.state", { status: requestStatuses.FETCHED, success : "ok", itemsCount : agentsArray.length});
            }
        }
        /**
         * The API returns the list of all agents.
         * This function filter only the relevance, sort them and return only the agents in the relevant page
         * @param agentListArray
         **/
        function getAgentsObject(agentListArray) {
            var agentsArray = [];
            var singleAgentObject;

            if (agentListArray && agentListArray.agent) {
                agentListArray = agentListArray.agent;
                // handle when only one agent returned from the api after filter was made
                if (agentListArray["@id"]) {
                    agentListArray = [agentListArray];
                }

                for (var i = 0; i < agentListArray.length; i++) {
                    singleAgentObject = getSingleAgentObject(agentListArray[i]);
                    if (singleAgentObject) {
                        agentsArray.push(singleAgentObject.agent);
                    }
                }
            }

            // Sort the agents
            agentsArray = sortAgents(agentsArray);
            lastCount = agentsArray.length;

            var skip = lastQuery.skip || 0;
            var limit = lastQuery.limit || 100;

            // Cut the list by the page
            return agentsArray.slice(skip, skip + limit);
        }

        function getSingleAgentObject(agentObject) {
            // return nothing if the agent is campaign manager and cannot receive chats
            if (agentObject.privilegeGroup === "campaign managers" && agentObject["@maxChats"] === "0") {
                return;
            }

            // return nothing if the agent is offline
            if (agentObject["@chatState"] === AGENT_STATUS.offline) {
                return;
            }

            // update reporting data
            reportingDatabarData.totalAgentsOnline += (agentObject["@chatState"] === AGENT_STATUS.online) ? 1 : 0;
            reportingDatabarData.totalAgentsBackSoon += (agentObject["@chatState"] === AGENT_STATUS.backSoon) ? 1 : 0;
            reportingDatabarData.totalAgentsAway += (agentObject["@chatState"] === AGENT_STATUS.away) ? 1 : 0;
            reportingDatabarData.concurrentChats += agentObject.chats ? parseInt(agentObject.chats, 10) : 0;
            if (agentObject["@chatState"] === AGENT_STATUS.online) {
                if (agentObject["@maxChats"] === "-1" || reportingDatabarData.maxConcurrentChats === -1) {
                    reportingDatabarData.maxConcurrentChats = -1; // indicates Unlimited
                }
                else {
                    reportingDatabarData.maxConcurrentChats += parseInt(agentObject["@maxChats"], 10);
                }

            }

            var chatState = (lastQuery.agentStatus && lastQuery.agentStatus.status) || defaultBodyData.status;
            // return nothing if agent's status is not the one filtered
            if (agentObject["@chatState"] !== chatState) {
                return;
            }

        return {
            agent: {
                id: agentObject["@id"],
                name: agentObject.userName,
                status: getAgentStatus(agentObject["@chatState"]),
                skills: setSkillsArray(agentObject),
                concurrent: agentObject.chats ? agentObject.chats : 0,
                maxConcurrent: agentObject["@maxChats"],
                nickname: agentObject.nickname,
                agentGroupId: agentObject.agentGroupId,
                agentGroupName: agentObject.agentGroupName,
                elapsedTimeInState: agentObject.elapsedTimeInState,
                chatReasonId: agentObject.chatReasonId}
        };
    }

        function setSkillsArray(agentObject) {
            var agentSkills = [];
            if (agentObject.skillsInfo) {
                var skills = agentObject.skillsInfo.skillInfo;
                // if the agent has only one skill put it as an item in the array
                if (skills.id && skills.name) {
                    agentSkills.push({id: skills.id, name: skills.name});
                }
                // if the agent has more then one skill then it's already an array
                else {
                    agentSkills = skills;
                    agentSkills.sort(getSortFunctionBySortTag("name"));
                }
            }
            return agentSkills;
        }

        function getAgentStatus(chatState) {
            var agentStatus = "Offline";
            switch (chatState) {
                case AGENT_STATUS.online :
                    agentStatus = "Online";
                    break;
                case AGENT_STATUS.backSoon :
                    agentStatus = "Back_Soon";
                    break;
                case AGENT_STATUS.away :
                    agentStatus = "Away";
                    break;
            }
            return agentStatus;
        }

        function readyToDisplay() {
            return receivedAgentList && receivedSkills;
        }

        function sortAgents(agentsArray) {
            agentsArray.sort(getSortFunctionBySortTag(lastQuery.sortTag));

            if (lastQuery.sortOrder === "desc") {
                agentsArray = agentsArray.reverse();
            }

            return agentsArray;
        }

        function getSortFunctionBySortTag(sortTag) {
            return function (e1, e2) {
                var e1_name = e1[sortTag].toLowerCase();
                var e2_name = e2[sortTag].toLowerCase();

                if (e1_name < e2_name) {
                    return -1;
                }
                else if (e1_name > e2_name) {
                    return 1;
                }
                return 0;
            };
        }

        function resetReportingData(value) {
            reportingDatabarData.totalAgentsOnline = value;
            reportingDatabarData.totalAgentsBackSoon = value;
            reportingDatabarData.totalAgentsAway = value;
            reportingDatabarData.concurrentChats = value;
            reportingDatabarData.maxConcurrentChats = value;
        }

        function apiStateChanged() {
            if (!readyToDisplay()) {
                var skillsState = agentListModel.get("skills.state");
                receivedSkills = !!skillsState && !!skillsState.success;
                if (readyToDisplay()) {
                    setAgentListArray(agentListModel.get("agentList.array"));
                    agentListModel.unbind('skills.state', apiStateChanged, this);
                }
            }
        }

        function getSessionData(data) {
            if (lpTag.WebAgent.WebAgentSessionStorage) {
                return lpTag.WebAgent.WebAgentSessionStorage.getSessionData(agentListController.applicationType + '_' + data.name, data.key);
            }
        }

        function saveSessionData(data) {
            if (lpTag.WebAgent.WebAgentSessionStorage) {
                lpTag.WebAgent.WebAgentSessionStorage.setSessionData(agentListController.applicationType + '_' + data.name, data.key, data.value);
            }
        }

        function removeSessionData(data) {
            if (lpTag.WebAgent.WebAgentSessionStorage) {
                lpTag.WebAgent.WebAgentSessionStorage.removeSessionData(agentListController.applicationType + '_' + data.name, data.key);
            }
        }

        // Return controller object
        return agentListController;

    };

    return lpAgentListController;

});
